// extracted by mini-css-extract-plugin
export default {"wrapper":"dga-z","play":"ega-z"};